var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 1041,
    viewBox: "0 0 375 1041",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_4989_4266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.168 34.5392C986.914 12.9225 975.925 58.8259 1092.03 146.706C1136.16 180.111 1065.95 215.039 1003.19 271.792C976.905 295.554 650.32 296.12 546.823 273.371C220.441 201.631 423.254 187.207 419.023 162.899C414.792 138.591 585.422 56.1558 786.168 34.5392Z",
    fill: "#FF6436"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4989_4266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.64 -128.84C759.952 -143.39 736.228 -102.771 889.356 -21.7991C947.561 8.98023 839.975 38.4386 739.439 87.5063C697.345 108.051 224.431 100.91 78.4651 78.2297C-381.845 6.70773 -85.7642 -1.38935 -87.7512 -23.1337C-89.7383 -44.8781 171.327 -114.29 465.64 -128.84Z",
    fill: "#0047FF",
    fillOpacity: 0.3,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4989_4266",
    x: -389.399,
    y: -720.761,
    width: 2245.25,
    height: 1760.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 375,
    result: "effect1_foregroundBlur_4989_4266"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4989_4266",
    x: -529.659,
    y: -481.753,
    width: 1785.43,
    height: 931.405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_4989_4266"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.58daeefb9b993f4eb63e70ccd2f86355.svg";
export { ForwardRef as ReactComponent };